import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';

const StudentRecord = () => {
  const { studentId } = useParams();
  const [studentData, setStudentData] = useState(null);

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const response = await axios.get('/registrationadvances');
        const student = response.data.find(student => student.id === parseInt(studentId, 10));
        if (student) {
          setStudentData(student);
        } else {
          console.error('Student not found');
        }
      } catch (error) {
        console.error('Error fetching student data:', error);
      }
    };

    fetchStudentData();
  }, [studentId]);

  if (!studentData) {
    return <div>Loading...</div>;
  }

  const renderNestedData = (key, value) => {
    if (Array.isArray(value)) {
      return (
        <Table size="small">
          <TableHead>
            <TableRow>
              {Object.keys(value[0]).map((subKey) => (
                <TableCell key={subKey}>{subKey}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {value.map((item, index) => (
              <TableRow key={index}>
                {Object.values(item).map((subValue, subIndex) => (
                  <TableCell key={subIndex}>{JSON.stringify(subValue)}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      );
    } else if (typeof value === 'object') {
      return (
        <Table size="small">
          <TableBody>
            {Object.entries(value).map(([subKey, subValue]) => (
              <TableRow key={subKey}>
                <TableCell>{subKey}</TableCell>
                <TableCell>{JSON.stringify(subValue)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      );
    }
    return JSON.stringify(value);
  };

  return (
    <div>
      <h2>Student Record</h2>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Field</TableCell>
              <TableCell>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(studentData).map(([key, value]) => (
              <TableRow key={key}>
                <TableCell>{key}</TableCell>
                <TableCell>{renderNestedData(key, value)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button onClick={() => window.history.back()}>Go Back</Button>
    </div>
  );
};

export default StudentRecord;